import { putCurations } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  UpdateCurationsServiceRequest,
  UpdateCurationsServiceResponse,
} from './update-curations.dto';
import {
  UpdateCurationsServiceRequestSchema,
  UpdateCurationsServiceResponseSchema,
} from './update-curations.dto';

export const updateCurationsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(UpdateCurationsServiceRequestSchema),
    async (request: UpdateCurationsServiceRequest): Promise<UpdateCurationsServiceResponse> => {
      const response = await putCurations({
        params: {
          curationId: request.curationId,
        },
        body: {
          title: request.title,
          description: request.description,
          type: request.type,
          goodsItems: request.goodsNoList.map((goodsNo) => Number(goodsNo)),
          snapItems: request.snapItems ?? [],
        },
      });

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이션 업데이트에 실패했습니다.');
      }

      return {
        success: true,
        curationId: response.data.curationId.toString(),
      };
    },
    validateServiceResponse(UpdateCurationsServiceResponseSchema),
  ),
);
